var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-main",
    { staticClass: "pa-2", attrs: { fluid: "" } },
    [
      _c("h1", [_vm._v("Users")]),
      _vm._v(" "),
      _c(
        "v-toolbar",
        { attrs: { flat: "" } },
        [
          _c(
            "v-dialog",
            {
              attrs: { persistent: "", "max-width": "900px" },
              on: {
                keydown: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "esc", 27, $event.key, [
                      "Esc",
                      "Escape"
                    ])
                  ) {
                    return null
                  }
                  _vm.dialog = false
                }
              },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function(ref) {
                    var on = ref.on
                    return [
                      _c(
                        "v-btn",
                        _vm._g({ attrs: { color: "primary", dark: "" } }, on),
                        [_vm._v("Add new User")]
                      )
                    ]
                  }
                }
              ]),
              model: {
                value: _vm.dialog,
                callback: function($$v) {
                  _vm.dialog = $$v
                },
                expression: "dialog"
              }
            },
            [
              _vm._v(" "),
              _c(
                "v-card",
                { attrs: { color: "lighten-1" } },
                [
                  _c(
                    "v-toolbar",
                    [
                      _c("v-toolbar-title", [
                        _c("span", { staticClass: "headline" }, [
                          _vm._v(_vm._s(_vm.formTitle))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("v-spacer")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-container",
                        [
                          _c(
                            "v-form",
                            {
                              ref: "form",
                              model: {
                                value: _vm.valid,
                                callback: function($$v) {
                                  _vm.valid = $$v
                                },
                                expression: "valid"
                              }
                            },
                            [
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", md: "12" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label: "Name",
                                          rules: _vm.nameRules,
                                          required: ""
                                        },
                                        model: {
                                          value: _vm.editedItem.name,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.editedItem,
                                              "name",
                                              $$v
                                            )
                                          },
                                          expression: "editedItem.name"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("v-text-field", {
                                        attrs: {
                                          disabled: _vm.editedIndex > -1,
                                          type: "email",
                                          label: "Email",
                                          rules: _vm.emailRules,
                                          "error-messages": _vm.emailErrorMsg,
                                          required: ""
                                        },
                                        on: { change: _vm.resetForm },
                                        model: {
                                          value: _vm.editedItem.email,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.editedItem,
                                              "email",
                                              $$v
                                            )
                                          },
                                          expression: "editedItem.email"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _vm.editedIndex === -1
                                        ? _c("v-text-field", {
                                            attrs: {
                                              label: "Password",
                                              hint: "6 or + characters",
                                              "persistent-hint": "",
                                              rules: _vm.passwordRules,
                                              counter: "",
                                              required: ""
                                            },
                                            model: {
                                              value: _vm.editedItem.password,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.editedItem,
                                                  "password",
                                                  $$v
                                                )
                                              },
                                              expression: "editedItem.password"
                                            }
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.editedIndex > -1 ||
                                      _vm.editedIndex === -1
                                        ? _c("v-select", {
                                            attrs: {
                                              items: _vm.roles,
                                              "item-disabled": "disabled",
                                              "item-text": "title",
                                              "item-value": "name",
                                              label: "Roles",
                                              multiple: "",
                                              chips: "",
                                              hint:
                                                "Add or remove roles to this user",
                                              "persistent-hint": ""
                                            },
                                            on: { change: _vm.checkMainRoles },
                                            model: {
                                              value: _vm.editedItem.roles,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.editedItem,
                                                  "roles",
                                                  $$v
                                                )
                                              },
                                              expression: "editedItem.roles"
                                            }
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.isInstructor
                                        ? _c("v-select", {
                                            attrs: {
                                              items: _vm.instructorObjs,
                                              label: "Select an Instructor",
                                              "item-text": "name",
                                              "item-value": "id",
                                              rules: _vm.nameRules
                                            },
                                            model: {
                                              value: _vm.editedItem.instructor,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.editedItem,
                                                  "instructor",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "editedItem.instructor"
                                            }
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.isPilot
                                        ? _c("v-select", {
                                            attrs: {
                                              items: _vm.pilotObjs,
                                              "item-text": "name",
                                              "item-value": "id",
                                              label: "Select a Pilot",
                                              rules: _vm.nameRules
                                            },
                                            model: {
                                              value: _vm.editedItem.pilot,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.editedItem,
                                                  "pilot",
                                                  $$v
                                                )
                                              },
                                              expression: "editedItem.pilot"
                                            }
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.isPacker
                                        ? _c("v-select", {
                                            attrs: {
                                              items: _vm.packerObjs,
                                              "item-text": "name",
                                              "item-value": "id",
                                              label: "Select a Packer",
                                              rules: _vm.nameRules
                                            },
                                            model: {
                                              value: _vm.editedItem.packer,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.editedItem,
                                                  "packer",
                                                  $$v
                                                )
                                              },
                                              expression: "editedItem.packer"
                                            }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "blue darken-1", text: "" },
                          on: { click: _vm.close }
                        },
                        [_vm._v("Cancel")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "blue darken-1",
                            type: "submit",
                            disabled: !_vm.valid
                          },
                          on: { click: _vm.save }
                        },
                        [_vm._v("Save")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("v-spacer"),
          _vm._v(" "),
          _c(
            "v-btn",
            { staticClass: "blue--text", attrs: { to: "/wages", link: "" } },
            [_c("v-icon", [_vm._v("mdi-chart-box")]), _vm._v("   Wages")],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "900px" },
          on: {
            keydown: function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
              ) {
                return null
              }
              _vm.tasksDialog = false
            }
          },
          model: {
            value: _vm.tasksDialog,
            callback: function($$v) {
              _vm.tasksDialog = $$v
            },
            expression: "tasksDialog"
          }
        },
        [
          _c(
            "v-card",
            { attrs: { color: "lighten-1" } },
            [
              _c(
                "v-toolbar",
                [
                  _c("v-toolbar-title", [
                    _c("span", { staticClass: "headline" }, [
                      _vm._v("Task's prices for " + _vm._s(_vm.editedItem.name))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("v-spacer")
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-container",
                    [
                      _c(
                        "v-form",
                        {
                          ref: "form",
                          model: {
                            value: _vm.valid,
                            callback: function($$v) {
                              _vm.valid = $$v
                            },
                            expression: "valid"
                          }
                        },
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "12", md: "12" } },
                                [
                                  _c("v-select", {
                                    attrs: {
                                      items: _vm.tasks,
                                      "item-text": "name",
                                      label: "Tasks",
                                      multiple: "",
                                      chips: "",
                                      hint: "Add or remove tasks to this user",
                                      "persistent-hint": "",
                                      "return-object": ""
                                    },
                                    model: {
                                      value: _vm.editedItem.tasks,
                                      callback: function($$v) {
                                        _vm.$set(_vm.editedItem, "tasks", $$v)
                                      },
                                      expression: "editedItem.tasks"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", md: "12" } },
                            [
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { col: "6", md: "6" } },
                                    [
                                      _c("v-subheader", [
                                        _vm._v("Fixed Price Tasks")
                                      ]),
                                      _vm._v(" "),
                                      _vm._l(_vm.editedItem.tasks, function(
                                        task
                                      ) {
                                        return _vm.editedItem.tasks.length > 0
                                          ? _c(
                                              "v-row",
                                              {
                                                key: task.id,
                                                staticClass:
                                                  "inline-numberfield-list",
                                                attrs: { value: task.name }
                                              },
                                              [
                                                task.type != "hr"
                                                  ? _c(
                                                      "v-col",
                                                      {
                                                        attrs: {
                                                          cols: "4",
                                                          md: "4"
                                                        }
                                                      },
                                                      [
                                                        _c("v-label", [
                                                          _vm._v(
                                                            _vm._s(task.name)
                                                          )
                                                        ])
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                task.type != "hr"
                                                  ? _c(
                                                      "v-col",
                                                      {
                                                        attrs: {
                                                          cols: "4",
                                                          md: "4"
                                                        }
                                                      },
                                                      [
                                                        _c("v-text-field", {
                                                          attrs: {
                                                            type: "number",
                                                            hint: task.type,
                                                            rules:
                                                              _vm.nameRules,
                                                            required: "",
                                                            "persistent-hint":
                                                              "",
                                                            "prepend-icon":
                                                              "mdi-currency-usd"
                                                          },
                                                          model: {
                                                            value: task.price,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                task,
                                                                "price",
                                                                _vm._n($$v)
                                                              )
                                                            },
                                                            expression:
                                                              "task.price"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e()
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      })
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-col",
                                    { attrs: { col: "6", md: "6" } },
                                    [
                                      _c(
                                        "v-row",
                                        [
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "4", md: "4" } },
                                            [
                                              _c("v-label", [
                                                _vm._v("Hourly Rate")
                                              ])
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-col",
                                            { attrs: { cols: "6", md: "6" } },
                                            [
                                              _c("v-text-field", {
                                                attrs: {
                                                  type: "number",
                                                  "prepend-icon":
                                                    "mdi-currency-usd"
                                                },
                                                model: {
                                                  value:
                                                    _vm.editedItem.hourly_rate,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.editedItem,
                                                      "hourly_rate",
                                                      _vm._n($$v)
                                                    )
                                                  },
                                                  expression:
                                                    "editedItem.hourly_rate"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "blue darken-1", text: "" },
                      on: { click: _vm.close }
                    },
                    [_vm._v("Cancel")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "blue darken-1",
                        type: "submit",
                        disabled: !_vm.valid
                      },
                      on: { click: _vm.saveTasks }
                    },
                    [_vm._v("Save")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("v-data-table", {
        staticClass: "elevation-1",
        attrs: { headers: _vm.headers, items: _vm.users, "items-per-page": 50 },
        scopedSlots: _vm._u([
          {
            key: "item.actions",
            fn: function(ref) {
              var item = ref.item
              return [
                _c(
                  "v-btn",
                  {
                    attrs: { icon: "", small: "" },
                    on: {
                      click: function($event) {
                        return _vm.edit(item)
                      }
                    }
                  },
                  [
                    _c("v-icon", { attrs: { center: "" } }, [
                      _vm._v("mdi-pencil")
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: { icon: "", small: "" },
                    on: {
                      click: function($event) {
                        return _vm.editTasks(item)
                      }
                    }
                  },
                  [
                    _c("v-icon", { attrs: { center: "" } }, [
                      _vm._v("mdi-account-cash")
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: { icon: "", small: "" },
                    on: {
                      click: function($event) {
                        return _vm.resetPassword(item.id)
                      }
                    }
                  },
                  [
                    _c("v-icon", { attrs: { center: "" } }, [
                      _vm._v("mdi-lock-reset")
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    staticClass: "red--text",
                    attrs: { icon: "", small: "" },
                    on: {
                      click: function($event) {
                        return _vm.deleteUser(item.id)
                      }
                    }
                  },
                  [_c("v-icon", [_vm._v("mdi-delete-forever")])],
                  1
                )
              ]
            }
          },
          {
            key: "item.status",
            fn: function(ref) {
              var item = ref.item
              return [
                _c("v-switch", {
                  attrs: {
                    success: item.status == 1 ? true : false,
                    inset: "",
                    label: _vm.getUserSwitchLabel(item.status)
                  },
                  on: {
                    change: function($event) {
                      return _vm.updateStatus(item)
                    }
                  },
                  model: {
                    value: item.status,
                    callback: function($$v) {
                      _vm.$set(item, "status", $$v)
                    },
                    expression: "item.status"
                  }
                })
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }